import { Order, RfiFieldOption, RfiFieldOptions, SearchRFIFilter } from '../../sdk';
import { Modify } from '../../types';
import { RFI_PAGE_LIMIT } from '../components/CustomDataView/helpers/constants';
import { getSdk } from '../components/helpers/getSdk';
import RFIMigration, { NormalizeRfi } from '../components/helpers/RFIMigration';

interface queryEntitiesParams {
  projectId: string;
  filters: {
    searchExpression?: string;
    offset?: number;
    filters?: SearchRFIFilter;
  };
  sort: { field: RfiFieldOption; order: Order };
}

interface QueryEntitiesResponse {
  data: NormalizeRfi[];
  nextPageQuery?: Modify<queryEntitiesParams, { RFI_PAGE_LIMIT: number }>;
}

export const queryEntities = async ({
  projectId,
  filters: { searchExpression, offset = 0, ...filters },
  sort,
}: queryEntitiesParams): Promise<QueryEntitiesResponse> => {
  const sdk = getSdk(projectId);
  const augmentedFilters = { bridgedTarget: false, ...filters };
  const hasSort = !!Object.keys(sort).length;
  const { results, pagination } = await sdk.RFIs.search({
    limit: RFI_PAGE_LIMIT,
    offset,
    fields: RfiFieldOptions,
    filter: augmentedFilters,
    ...(hasSort && { sort: [{ field: sort.field, order: sort.order }] }),
    ...(searchExpression && { search: searchExpression }),
  });

  const hasNextPage = pagination.totalResults > offset + RFI_PAGE_LIMIT;
  const deserializeFunc = RFIMigration.deserialize;
  const deserializedRfis = results.map(deserializeFunc);

  return {
    data: deserializedRfis,
    nextPageQuery: hasNextPage
      ? {
          projectId,
          RFI_PAGE_LIMIT,
          filters: {
            searchExpression,
            ...filters,
            offset: offset + RFI_PAGE_LIMIT,
          },
          sort,
        }
      : undefined,
  };
};
